import React, { Fragment, useRef } from "react";
import { AUTO_ATTRS } from "components/Form/fields/constants";
import Label from "components/Form/fields/Label";
import FieldError from "components/FieldError";
import { useFormikContext } from "formik";
import classnames from "classnames";
import get from "lodash/get";
import { getFieldNameRoot, getFieldPath } from "utils/form";
import { INPUT_CLASSES } from "utils/constants/ui";

const UncontrolledInput = ({
  edit,
  valueSet,
  placeholder,
  label,
  name,
  hideError,
  innerRef,
  error,
  required,
  ...props
}) => {
  const formRef = useRef(null);
  const ctxRef = innerRef || formRef;
  const { touched, errors } = useFormikContext();
  const ctxError = error || get(errors, name);
  const nameRoot = getFieldNameRoot(name);
  const labelPath = getFieldPath(nameRoot, "label");
  const isTouched = get(touched, name);
  const showError = Boolean(isTouched && ctxError && !hideError);

  const disabled = Boolean(props.disabled);

  const fieldInput = {
    className: classnames(INPUT_CLASSES, {
      "b--red": showError,
      "b--black-20": !showError,
      "cursor-not-allowed": disabled
    }),
    placeholder: placeholder || "",
    ...AUTO_ATTRS,
    onChange: (evt) => {
      valueSet(evt.target.value);
    },
    onBlur: (evt) => {
      valueSet(evt.target.value);
    },
    ref: ctxRef,
    ...props,
    disabled
  };

  return (
    <Fragment>
      {(label || edit) && (
        <Label
          edit={edit}
          name={labelPath}
          label={label}
          error={showError}
          required={required}
        />
      )}
      <input {...fieldInput} />
      {showError && <FieldError error={ctxError} name={name} />}
    </Fragment>
  );
};
export default UncontrolledInput;
